module.exports = __webpack_public_path__ + "static/media/non_ulip.2965fe44.mp3";